export const regexName = /^[0-9a-zA-Zá-žÁ-Ž. \.\-\&\,]*$/;
export const regexSurname = /^[0-9a-zA-Zá-žÁ-Ž \.\-\&\,]*$/;
export const regexZipCode = /^[0-9]*$/;
export const regexBusinessName = /^[0-9a-zA-Zá-žÁ-Ž.\-&,!@#$()?+:\s]*$/;
export const regexNumber = /^[0-9]*$/;
export const regexDocumentId = /^[0-9a-zA-Z]*$/;
export const regexLogin = /^[0-9a-zA-Zá-žÁ-Ž\\_.]*$/;
export const dayMonthsAcceptedFormats = /^(0[1-9]|[12][0-9]|3[01])[/.]?(0[1-9]|1[012])$/;
export const regexDate = /^[0-9./]+$/;
export const regexNote = /^[^\"\']*$/;
export const regexMunicipality = /^[a-zA-Zá-žÁ-Ž0-9. -]*$/;
export const regexNoteSemaphore = /^[^~°#$^{}\[\]|\\]*$/;
export const businessCaseLastCharacter = ['A'];
export const regexEmail =
	/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/;
export const regexProposal = /^[0-9a-zA-Zá-žÁ-Ž-.\\\\/]*$/;
export const regexTitle = /^[a-zA-Zá-žÁ-Ž. -]*$/;
export const regexStreetNumber = /^[a-zA-Zá-žÁ-Ž0-9. \-/]*$/;
export const regexPhoneNumber = /^(?:(?:(?:\+|00)[0-9]{1,3})[0-9]{8,9}|[0-9]{9})$/;
export const regexClaimNumber = /^[0-9a-zA-Zá-žÁ-Ž. \.\-\/]*$/;
export const regexSpecialCharacters = /^[^~°!?@#$%=^{}\[\]|\\]*$/;
export const regexContactProduct = /^[0-9a-zA-Zá-žÁ-Ž\. \-\*\+\/\(\)\,\%\_\s]*$/;
